import UseResponsive from "@/utils/hooks/useResponsive";
import React from "react";
import ComponentNotification from "./components/Notification";

export default function Notification() {
  return (
    <UseResponsive>
      <ComponentNotification />
    </UseResponsive>
  );
}
